
import { useQuery } from '@tanstack/react-query';
import backendApi from '../services/axios.auth.wrapper';

const baseURL = process.env.REACT_APP_BACKEND_URL;


export const useFeatureFlag = (
  companyId: number,
  featureName: string
) =>
  useQuery<boolean, Error>(
    ['feature-flag', companyId, featureName],
    () =>
      backendApi({
        method: 'post',
        url: `${baseURL}/api/feature_flag`,
        data: {
          company_id: companyId,
          feature_name: featureName,
        },
      }).then(response => response.data),   
    {
      enabled: companyId > 0,
      initialData: false,      
    }
  );